import React from 'react';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';
import Tooltip, { TooltipPrimitive } from '@atlaskit/tooltip';
import { Size } from '@atlaskit/icon';
import { Y200 } from '@atlaskit/theme/colors';
import { QuoteV2 } from '@atlassian/cssxp-types-quote';
import { sentenceCase } from '@atlassian/cssxp-utils-generic';

interface QuoteWarningIconProps {
  size?: Size;
  titleContent?: React.ReactNode;
}

const InlineDialog = styled(TooltipPrimitive)`
  background: white;
  border-radius: ${token('border.radius', '4px')};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  box-sizing: content-box;
  padding: ${token('space.100', '8px')} ${token('space.150', '12px')};
  max-width: 400px;
`;

export const QuoteWarningIcon = ({ size, titleContent }: QuoteWarningIconProps) => {
  return (
    <Tooltip
      component={InlineDialog}
      content={titleContent ?? sentenceCase(QuoteV2.QuoteStatus.NEEDS_REVIEW)}
      tag="span"
    >
      <div className="stale-status" data-testid="stale-status">
        <WarningIcon label="" primaryColor={Y200} size={size} />
      </div>
    </Tooltip>
  );
};
